import { useUser } from '@fs/zion-user'
import { trackEvent } from '@fs/zion-analytics'

export default function useTrackOverviewEvent() {
  const { signedIn } = useUser()
  const link_page = signedIn ? 'Overview' : 'Overview-LO'

  return (link_name) => {
    if (!link_name) return

    trackEvent({ link_app: 'Memories', link_page, link_name })
  }
}
